import React, { useState } from 'react';

import firebase from '../firebase';
import { IMAGE_GUIDE_LINK } from '../utils/constants';

const FIELDS = {
    author: 'author',
    title: 'title',
    file: 'file',
    use: 'use',
};

const USE_REQ_PERMISSIONS = 'website';

function BroadcastImageModal({ setModalOpen, selectedBroadcast, getBroadcastDetails }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imageTitle, setImageTitle] = useState('');
    const [imageAuthor, setImageAuthor] = useState('');
    const [imageFile, setImageFile] = useState('');
    const [imageFilename, setImageFilename] = useState('');
    const [imageUse, setImageUse] = useState('');

    function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);

        const broadcastId = selectedBroadcast.id;
        firebase.uploadBroadcastImage({ broadcastId, imageTitle, imageAuthor, imageFile, imageUse })
            .then(() => getBroadcastDetails(broadcastId))
            .catch(() => {
                alert('Something went wrong. Please try again and check that the image does not exceed the maximum file size.');
            })
            .finally(() => {
                setIsSubmitting(false);
                setModalOpen(null);
            });
    }

    function onCancelClick() {
        setModalOpen(null);
    }

    function handleChange(e) {
        const { value, name, files } = e.target;
        switch(name) {
            case FIELDS.author:
                setImageAuthor(value);
                break;
            case FIELDS.title:
                setImageTitle(value);
                break;
            case FIELDS.use:
                setImageUse(value);
                break;
            case FIELDS.file:
                setImageFilename(value);
                setImageFile(files[0]);
                break;
        }
    }

    return (
        <div>
            <div className="full-page-overlay" onClick={onCancelClick} />
            <div className="modal-container">
                <div className="modal-container__modal edit-modal">
                    <form onSubmit={handleSubmit}>
                        <div>
                            <label className="mdl-typography--body-1" htmlFor="use">
                                What can this image be used for?*
                            </label>
                        </div>
                        <div className="mdl-textfield" style={{ paddingTop: '2px', paddingBottom: '12px' }}>
                            <select className="mdl-textfield__input" required name="use" id="use" onChange={handleChange}>
                                <option value="">Please select</option>
                                <option value={USE_REQ_PERMISSIONS}>Website</option>
                                <option value="socials">Social suggestion</option>
                                <option value={USE_REQ_PERMISSIONS + " and socials"}>Both</option>
                            </select>
                        </div>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="title">
                                Title*
                            </label>
                            <input
                                required
                                placeholder="Name of the image"
                                id="title"
                                className="mdl-textfield__input edit-modal__input"
                                type="text"
                                name={FIELDS.title}
                                value={imageTitle}
                                onChange={handleChange} />
                        </div>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="author">
                                Author*
                            </label>
                            <input
                                required
                                placeholder="Owner of the image or photographer"
                                id="author"
                                className="mdl-textfield__input edit-modal__input"
                                type="text"
                                name={FIELDS.author}
                                value={imageAuthor}
                                onChange={handleChange} />
                        </div>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="image">
                                Image*
                            </label>
                            <input
                                required
                                id="image"
                                className="mdl-textfield__input edit-modal__input"
                                type="file"
                                accept="image/jpeg,image/png"
                                name={FIELDS.file}
                                value={imageFilename}
                                onChange={handleChange} />
                        </div>
                        <div style={{ marginBottom: "12px" }}>
                        </div>
                        {!!imageUse && imageUse.includes(USE_REQ_PERMISSIONS) && (
                            <div style={{ marginBottom: "12px" }}>
                                <strong>Specs:</strong> the image for the website should be in PNG or JPEG format and 16:9 ratio (landscape) with height minimum 1400px and maximum 6000px. Maximum file size is 10MB.
                                <br /><br />
                                <strong>Credits and permissions:</strong> Images without permission or credit can’t be use on the website. For more info please read the{" "}
                                <a href={IMAGE_GUIDE_LINK} target="_blank" rel="noreferrer">guide</a>.
                                <br /><br />
                                <label htmlFor="permission-check">
                                    <input required type="checkbox" id="permission-check" style={{ marginRight: "5px" }} />
                                    <span style={{ verticalAlign: "top" }}>
                                        I confirm I have permission for this image to be published on the NTS website.
                                    </span>
                                </label>
                            </div>
                        )}
                        {!!imageUse && !imageUse.includes(USE_REQ_PERMISSIONS) && (
                             <div style={{ marginBottom: "12px" }}>
                             <strong>Specs:</strong> the image for social promotion should be in PNG or JPEG format and 1080 x 1350 pixels (4:5 ratio). Maximum file size is 10MB.
                             <br /><br />
                             <strong>Usage:</strong> the NTS team will consider the image as promotional material on our official social media channels.
                            </div>
                        )}
                        <div className="edit-modal__buttons">
                            <button
                                className="mdl-button mdl-button--raised button-responsive"
                                name="cancel"
                                type="button"
                                onClick={onCancelClick}
                                disabled={isSubmitting}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="mdl-button mdl-button--raised button-blue button-responsive"
                                name="save"
                                disabled={isSubmitting}>
                                Upload
                                {isSubmitting &&
                                    <i className="material-icons rotating" role="presentation">
                                        rotate_right
                                    </i>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default BroadcastImageModal;
